import { createDismissKeyStack, useDismissKeyClaim } from './dismiss-key-stack';

/**
 * WEB: the dismiss key is `Escape`. See the `.native` sibling and
 * `dismiss-key-stack` for the stacking rules.
 */
export const dismissKeyStack = createDismissKeyStack((dispatch) => {
  if (typeof document === 'undefined') return () => {};
  const onKeyDown = (event: KeyboardEvent) => {
    if (event.key === 'Escape') dispatch();
  };
  document.addEventListener('keydown', onKeyDown);
  return () => document.removeEventListener('keydown', onKeyDown);
});

/** Hold `Escape` while `active` — see {@link useDismissKeyClaim}. */
export function useDismissKey(active: boolean, onDismissKey: () => void) {
  useDismissKeyClaim(dismissKeyStack, active, onDismissKey);
}
